<script setup lang="ts">
import { Target } from 'lucide-vue-next'
import { storeToRefs } from 'pinia'
import { useGoalStore, useProjectStore } from '@/stores/domain'

const { goals } = storeToRefs(useGoalStore())
const projectStore = useProjectStore()
const projectName = (projectId?: string): string =>
  projectId ? projectStore.projects.find((project) => project.id === projectId)?.name ?? 'Project' : 'Portfolio'
</script>

<template>
  <div class="section-page">
    <header class="section-page__header">
      <div><span class="eyebrow">Portfolio</span><h1>Goals</h1><p>Measurable outcomes across your projects and portfolio.</p></div>
      <RouterLink class="button button--dark" to="/app/manager">Create through Manager</RouterLink>
    </header>
    <div v-if="goals.length" class="project-grid">
      <article v-for="goal in goals" :key="goal.id" class="project-card">
        <div class="project-card__top"><span class="project-icon"><Target :size="18" /></span><span class="status-pill"><i></i>{{ goal.status }}</span></div>
        <h2>{{ goal.title }}</h2><p>{{ goal.description }}</p>
        <div class="project-card__objective"><span>{{ projectName(goal.projectId) }}</span><strong>{{ goal.metric }}</strong></div>
      </article>
    </div>
    <div v-else class="detail-card"><h2>No goals yet</h2><p>Ask your Manager to create a measurable portfolio or project goal.</p></div>
  </div>
</template>
